<template>
  <div>
    <div class="record1"></div>
    <div class="record2">
      <el-form ref="added" inline size="medium">
        <el-form-item label="标题">
          <el-input @keyup.enter.native="search" v-model="query.title" placeholder="请输入标题"
            clearable show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.publish_status" placeholder="请选择状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="待发布" :value="10"></el-option>
            <el-option label="已发布" :value="20"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item v-if="JudgeButton(role_permission,'notice/query')">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'notice/query')">
          <el-button type="info" icon="el-icon-refresh-left" @click="query.title= '';query.publish_status='';search()">重置</el-button>
        </el-form-item>
        <el-form-item v-if="JudgeButton(role_permission,'notice/increase')">
          <el-button type="success" icon="el-icon-circle-plus" @click="$refs.addOrEdit.show('')"> 新增 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="record3">
      <el-table v-loading='loading' stripe border :data="list" tooltip-effect="dark" style="width: 98%">
        <el-table-column align='center' prop="title" label="标题">
        </el-table-column>
        <el-table-column align='center' label="推送用户" :formatter="(row) => notice_scope_fun(row)"></el-table-column>
        <el-table-column align='center' prop="publish_type" label="推送渠道" :formatter="(row) => publish_type_fun(row)"></el-table-column>

        <!-- <el-table-column align='center' prop="service_project_name" label="推送渠道">
        </el-table-column> -->

        <el-table-column align='center' prop="created_user" label="创建人" width="120"></el-table-column>
        <el-table-column align='center' prop="timing_time" label="推送时间" :formatter="(row) => timing_time_fun(row)" width="150">
        </el-table-column>
        <el-table-column align='center' label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.publish_status == 10" style="color: #ffac1c;">待发布</span>
            <span v-if="scope.row.publish_status == 20" style="color: #0dcd2e;">已发布</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align='center' width="240">
          <template slot-scope="scope">
            <el-button v-if="JudgeButton(role_permission,'notice/query')" size="mini" type="primary"
              @click="$refs.detail.show(scope.row)">查看</el-button>
            <el-button v-if="JudgeButton(role_permission,'notice/edit') && scope.row.publish_status == 10" size="mini" type="primary"
              @click="$refs.addOrEdit.show(scope.row)">编辑</el-button>
            <el-button v-if="JudgeButton(role_permission,'notice/delete')" size="mini"
               type="danger" @click="handleDelete(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>
    <addOrEditDialog ref='addOrEdit' @success='getList()'></addOrEditDialog>
    <detailDialog ref="detail"></detailDialog>
  </div>
</template>
<script>
  import userInfoAPI from '@/api/api';
  import addOrEditDialog from  './components/addOrEditDialog.vue'
  import detailDialog from  './components/detailDialog.vue'
  import { publish_type, user_type } from  '@/filters'
  var that;
  export default {
    components: {
      addOrEditDialog,
      detailDialog
    },
    props: {},
    data() {
      return {
        loading: true,
        query: {
          page_limit: 10,
          page: 1,
          title: '',
          publish_status: '',
          total: 0
        },
        list: [],
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    watch: {},
    created() {
      that = this;
      if (this.$store.state.cache.cacheNoticeQuery) this.query = this.$store.state.cache.cacheNoticeQuery
      this.getList()
    },
    beforeDestroy() {
      this.$store.commit('CACHE_NOTICE', this.query)
    },
    methods: {
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      notice_scope_fun(row){
        let map = new Map();
        let user_types = row.notice_scope.filter(item => !map.has(item['user_type']) && map.set(item['user_type'],1))
        user_types = user_types.map(i=>{
          return user_type(i.user_type)
        })
        return user_types.join('、')
      },
      publish_type_fun(row){
        if(typeof row.publish_type === 'string')
          row.publish_type = JSON.parse(row.publish_type)
        return row.publish_type.map(i=>{
          return publish_type(i)
        }).join('、')
        // return row.publish_type
      },
      timing_time_fun(row){
        if(row.is_timer){
          return row.publish_time
        }else{
          return '-'
        }
      },
      search() {
        this.loading = true;
        this.query.page = 1;
        this.list = [];
        this.getList()
      },
      handleDelete(row) { //删除
        this.$confirm('此操作将永久删除该记录, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.delInNotice(row.id).then(res => {
            if (res.data.code == 0) {
              this.$message.success(res.data.msg)
              this.getList()
            }else{
              
            }
          })
        })
      },
      getList() {
        this.loading = true
        let query = JSON.parse(JSON.stringify(this.query))
        userInfoAPI.getNoticeList(this.query).then(res => {
          if (res && res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.getList();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .record1 {
    height: 20px;
  }

  .record3 {
    margin-left: 20px;
  }

  .record2 .el-form-item {
    margin-left: 20px;
  }
</style>
